import React, { useState, useEffect } from "react";
import "./OnionBuy.css"; // Assuming the same CSS file can be used, otherwise create a new CSS file.
import { useAuth } from "./AuthContext";
import { Link } from "react-router-dom";
import Whyglobal from "../Components/Whyglobal";

const DryFruitBuys = [
  {
    name: "Anjali Kapoor",
    email: "anjali.kapoor17@example.com",
    mobileNumber: "9876543210",
    locationandDate: "06-12-2024",
    lookingFor: "Urgent Plastic Dry Fruit Boxes",
    productOrService: "Plastic Dry Fruit Boxes",
    quantity: 50,
    unit: "boxes",
    _id: "ac9a1f2e3bfa5c9b1d39fd33a",
  },
  {
    name: "Rahul Mehta",
    email: "rahul.mehta42@example.com",
    mobileNumber: "9912345678",
    locationandDate: "05-12-2024",
    lookingFor: "Urgent Plastic Dry Fruit Box Set",
    productOrService: "Plastic Dry Fruit Box Set",
    quantity: 30,
    unit: "sets",
    _id: "e29c8b6d4a2a6b1d8f03212c7",
  },
  {
    name: "Ravi Patel",
    email: "ravi.patel32@example.com",
    mobileNumber: "9898765432",
    locationandDate: "04-12-2024",
    lookingFor: "Plastic Dry Fruit Box",
    productOrService: "Plastic Dry Fruit Box",
    quantity: 20,
    unit: "boxes",
    _id: "f729b6a8c64d9d76b8e8f532d",
  },
  {
    name: "Neha Soni",
    email: "neha.soni56@example.com",
    mobileNumber: "9822334455",
    locationandDate: "03-12-2024",
    lookingFor: "Urgent Bulk Plastic Dry Fruit Boxes",
    productOrService: "Plastic Dry Fruit Boxes",
    quantity: 100,
    unit: "boxes",
    _id: "d75e8b7e3c29b3dbfbb8e7289",
  },
  {
    name: "Alok Sharma",
    email: "alok.sharma28@example.com",
    mobileNumber: "9812345678",
    locationandDate: "02-12-2024",
    lookingFor: "Plastic Dry Fruit Box Set",
    productOrService: "Plastic Dry Fruit Box Set",
    quantity: 40,
    unit: "sets",
    _id: "cc2181d84a5d42d2b9b9cfe85",
  },
  {
    name: "Suman Yadav",
    email: "suman.yadav71@example.com",
    mobileNumber: "9901122334",
    locationandDate: "01-12-2024",
    lookingFor: "Plastic Dry Fruit Boxes",
    productOrService: "Plastic Dry Fruit Boxes",
    quantity: 35,
    unit: "boxes",
    _id: "c4a0b1d6e978b4bbf7c6229d1",
  },
  {
    name: "Manish Kumar",
    email: "manish.kumar91@example.com",
    mobileNumber: "9834567890",
    locationandDate: "06-11-2024",
    lookingFor: "Plastic Dry Fruit Box",
    productOrService: "Plastic Dry Fruit Box",
    quantity: 25,
    unit: "boxes",
    _id: "b4a8f0e2c9b8b48b22c9abbd4",
  },
  {
    name: "Pooja Gupta",
    email: "pooja.gupta56@example.com",
    mobileNumber: "9098765432",
    locationandDate: "07-11-2024",
    lookingFor: "Urgent Plastic Dry Fruit Boxes",
    productOrService: "Plastic Dry Fruit Boxes",
    quantity: 50,
    unit: "boxes",
    _id: "e742c5f8b2f1f39db3e2b0621",
  },
  {
    name: "Vikram Singh",
    email: "vikram.singh45@example.com",
    mobileNumber: "9901234567",
    locationandDate: "07-11-2024",
    lookingFor: "Bulk Plastic Dry Fruit Boxes",
    productOrService: "Plastic Dry Fruit Boxes",
    quantity: 60,
    unit: "boxes",
    _id: "a9f5e29d7c2a49dba8f92521d",
  },
  {
    name: "Amit Shah",
    email: "amit.shah23@example.com",
    mobileNumber: "9811122334",
    locationandDate: "07-11-2024",
    lookingFor: "Plastic Dry Fruit Box",
    productOrService: "Plastic Dry Fruit Box",
    quantity: 15,
    unit: "boxes",
    _id: "ed7c19b91a79ad1b0a68f0ac9",
  },
  {
    name: "Sunita Reddy",
    email: "sunita.reddy64@example.com",
    mobileNumber: "9934567890",
    locationandDate: "06-11-2024",
    lookingFor: "Urgent Plastic Dry Fruit Box Set",
    productOrService: "Plastic Dry Fruit Box Set",
    quantity: 20,
    unit: "sets",
    _id: "d8a4c1f6e0543d7b5f77361ac",
  },
  {
    name: "Rajeev Gupta",
    email: "rajeev.gupta21@example.com",
    mobileNumber: "9098765432",
    locationandDate: "07-11-2024",
    lookingFor: "Plastic Dry Fruit Box",
    productOrService: "Plastic Dry Fruit Box",
    quantity: 30,
    unit: "boxes",
    _id: "e47bcd66f402d4d688ba0a91b",
  },
  {
    name: "Deepa Joshi",
    email: "deepa.joshi74@example.com",
    mobileNumber: "9812772210",
    locationandDate: "06-11-2024",
    lookingFor: "Urgent Plastic Dry Fruit Boxes",
    productOrService: "Plastic Dry Fruit Boxes",
    quantity: 80,
    unit: "boxes",
    _id: "b60a762f6a5398bcfbedfc77c",
  },
  {
    name: "Tarun Desai",
    email: "tarun.desai11@example.com",
    mobileNumber: "9801234567",
    locationandDate: "07-11-2024",
    lookingFor: "Bulk Plastic Dry Fruit Box Set",
    productOrService: "Plastic Dry Fruit Box Set",
    quantity: 45,
    unit: "sets",
    _id: "c22b7649d8c6db9b462d2b87c",
  },
];

const DryFruitBuy = () => {
  const { userId } = useAuth();
  const [userIsPremium, setUserIsPremium] = useState(false);
  const [shownNumbers, setShownNumbers] = useState([]);
  const [leadsViewed, setLeadsViewed] = useState(0);

  useEffect(() => {
    if (!userId) return;

    // Load the viewed leads from local storage
    const storedViewedLeads =
      JSON.parse(localStorage.getItem(`dryFruitViewedLeads_${userId}`)) || [];
    setShownNumbers(storedViewedLeads);

    fetch(
      `${process.env.REACT_APP_API_ENDPOINT}/getUserWithPremiumStatus/${userId}`
    )
      .then((response) => response.json())
      .then((data) => {
        setUserIsPremium(data.isPremium);
        setLeadsViewed(data.leadsViewed);
        console.log("Premium Status:", data.isPremium);
      })
      .catch((error) => {
        console.error("Error fetching user information:", error);
      });
  }, [userId]);

  const toggleNumber = async (index) => {
    if (!userIsPremium) return; // Only premium users can see numbers

    if (leadsViewed >= 25) {
      alert("You have reached the limit of 25 leads viewed per month.");
      return;
    }

    if (shownNumbers.includes(index)) return; // If already shown, do nothing

    const updatedShownNumbers = [...shownNumbers, index];
    setShownNumbers(updatedShownNumbers);

    // Update local storage
    localStorage.setItem(
      `dryFruitViewedLeads_${userId}`,
      JSON.stringify(updatedShownNumbers)
    );

    const buyer = DryFruitBuys[index]; // Get the buyer information

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_ENDPOINT}/incrementLeadsViewed/${userId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            buyerName: buyer.name,
            mobileNo: buyer.mobileNumber,
          }),
        }
      );

      if (response.ok) {
        const data = await response.json();
        setLeadsViewed(data.leadsViewed);
      } else {
        const errorData = await response.json();
        console.error("Error incrementing leads viewed:", errorData.error);
      }
    } catch (error) {
      console.error("Error incrementing leads viewed:", error.message);
    }
  };

  return (
    <>
      <div className="container">
        <ol className="breadcrumb">
          <li
            style={{
              display: "flex",
              justifyContent: "center",
              margin: "5px 30px",
            }}
            className="breadcrumb-item"
          >
            <Link to={"/"}>Home</Link>
          </li>
          <li
            style={{
              display: "flex",
              justifyContent: "center",
              margin: "5px -25px",
            }}
          >
            /
          </li>
          <li
            style={{
              display: "flex",
              justifyContent: "center",
              margin: "5px 30px",
            }}
            className="breadcrumb-item active"
          >
            Fresh Leads
          </li>
        </ol>
      </div>
      <div className="containersx">
        <div style={{ width: "200px", padding: "10px" }} className="browsers">
          <h3 style={{ marginTop: "30px" }}>Browse by State</h3>
          <ul className="flt-list cust-scroll" id="state-lists">
            <li>
              <Link to="#">All India</Link>
            </li>
            <li>
              <Link to="#">Delhi</Link>
            </li>
            <li>
              <Link to="#">Maharashtra</Link>
            </li>
            <li>
              <Link to="#">Karnataka</Link>
            </li>
            <li>
              <Link to="#">West Bengal</Link>
            </li>
            <li>
              <Link to="#">Tamil Nadu</Link>
            </li>
          </ul>

          <ul style={{ marginTop: "20px" }} className="flt-list cust-scroll">
            <h3>All Category</h3>
            <li>
              <Link to="#">Plastic Dry Fruit Box</Link>
            </li>
          </ul>
        </div>
        <div className="buyers">
          {DryFruitBuys.map((buyer, index) => (
            <div key={index} className="buyer-card">
              <h2 style={{ color: "red" }}> {buyer.lookingFor}</h2>
              <p>
                <strong>Buyer Name:</strong> {buyer.name}
              </p>
              <p>
                <strong>Quantity:</strong> {buyer.quantity} {buyer.unit}
              </p>
              <p>
                <strong>Date:</strong> {buyer.locationandDate}{" "}
              </p>
              <p>
                <strong>Mobile No.:</strong>{" "}
                {userIsPremium
                  ? shownNumbers.includes(index)
                    ? buyer.mobileNumber
                    : "********"
                  : "********"}
              </p>
              <div style={{ display: "flex", gap: "10px" }}>
                {userIsPremium && (
                  <button
                    className="detail-btn"
                    style={{
                      padding: "5px 10px",
                      background: "#f7f1f1",
                      color: "orange",
                      borderRadius: "3px",
                      cursor: "pointer",
                    }}
                    onClick={() => toggleNumber(index)}
                  >
                    Click to see
                  </button>
                )}
              </div>
              <div className="btns-imp">
                <Link to={"/login"}>
                  <button className="detailing-btn">View More</button>
                </Link>
                <Link to={"/register-Company"}>
                  <button className="regis-btn">Register Now</button>
                </Link>
              </div>
            </div>
          ))}
        </div>
        <div className="sidebar">
          <div className="mains-slide">
            <div className="tk23-hkCont_onergt">
              <div className="tk23-hkCont_premserv__box">
                <h1 className="tk23-hkCont_premserv__ttl">
                  Our Membership Plans
                </h1>
                <div className="tk23-hkCont_premserv__list">
                  <Link to={"/packages"}>
                    <div className="tk23-hkCont_premservs">
                      <span
                        className="fontss"
                        style={{ backgroundColor: "#fff" }}
                      >
                        Standard Plan
                      </span>
                    </div>
                  </Link>
                </div>
                <div className="tk23-hkCont_premserv__list">
                  <Link to={"/packages"}>
                    <div className="tk23-hkCont_premservs">
                      <span
                        className="fontss"
                        style={{ backgroundColor: "#fff" }}
                      >
                        Advance Plan
                      </span>
                    </div>
                  </Link>
                </div>
                <div className="tk23-hkCont_premserv__list">
                  <Link to={"/packages"}>
                    <div className="tk23-hkCont_premservs">
                      <span
                        className="fontss"
                        style={{ backgroundColor: "#fff" }}
                      >
                        Premium Plan
                      </span>
                    </div>
                  </Link>
                  <Link to={"/packages"}>
                    <div className="reach">
                      <span className="reahhere">Call Now</span>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Whyglobal />
      </div>
    </>
  );
};

export default DryFruitBuy;
